import React from "react";
import { Typography } from "@mui/material";
import { FaChevronDown } from "react-icons/fa";
import * as S from "./style";
import { StatusReserva } from "./utils";

export const HistoricoRevenda = ({
  data,
  podeVerDadosProprietario,
}: {
  data: any;
  podeVerDadosProprietario: boolean;
}) => {
  return (
    <div>
      <S.Accordion
        disableGutters
        elevation={0}
        square
        sx={{ boxShadow: "none", borderRadius: "8px" }}
      >
        <S.AccordionSummary
          aria-controls="panel1-content"
          id="panel1-header"
          expandIcon={<FaChevronDown size={14} color="black" />}
        >
          <Typography>{"Histórico de Acompanhamento"}</Typography>
        </S.AccordionSummary>
        <S.AccordionDetails>
          {!data || data?.length === 0 ? (
            <p style={{ textAlign: "center", fontSize: 14, fontWeight: 600 }}>
              {"Nenhuma entrada encontrada"}
            </p>
          ) : (
            data?.map((item: any) => (
              <div className="item" key={item?.id}>
                <div style={{ display: "flex", gap: 12 }}>
                  <div>
                    <p>
                      {"Status: "}
                      <span>
                        {item?.revendaStatus
                          ? StatusReserva[item?.revendaStatus]
                          : "--"}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      {"Data: "}
                      <span>
                        {item?.dataCriacao
                          ? new Date(item?.dataCriacao)?.toLocaleDateString(
                              "pt-BR"
                            )
                          : "--/--/----"}
                      </span>
                    </p>
                  </div>
                </div>
                <S.Divider />
                <div style={{ display: "flex", gap: 12 }}>
                  <div>
                    <p>
                      {"Responsável: "}
                      <span>{item?.responsavelPelaAlteracao ?? "--"}</span>
                    </p>
                  </div>
                  <div>
                    <p>
                      {item?.isHistorico ? "Alteração: " : "Acompanhamento: "}
                    </p>
                    <p style={{ fontWeight: 400 }}>
                      {item?.acompanhamento
                        ? item.acompanhamento
                            .split(/\r?\n/)
                            .map((linha: string) => (
                              <React.Fragment
                                key={linha.trim() + Math.random()}
                              >
                                {linha}
                                <br />
                              </React.Fragment>
                            ))
                        : "--"}
                    </p>
                  </div>
                </div>
                {typeof item?.nomeCliente === "string" &&
                  !!item?.nomeCliente &&
                  podeVerDadosProprietario && (
                    <div style={{ display: "flex", gap: 12 }}>
                      <div>
                        <p>
                          {"Nome do cliente: "}
                          <span>{item?.nomeCliente}</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          {"RG do cliente: "}
                          <span>{item?.rgCliente ?? "--"}</span>
                        </p>
                      </div>
                    </div>
                  )}
                {typeof item?.vendidoSemNossaIntermediacao === "boolean" && (
                  <div>
                    <p>
                      {"Vendido sem a nossa intermediação: "}
                      <span>
                        {item?.vendidoSemNossaIntermediacao ? "Sim" : "Não"}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            ))
          )}
        </S.AccordionDetails>
      </S.Accordion>
    </div>
  );
};
